import { Link } from 'gatsby';
import React from 'react';
const Packages = () => (
  <>
    <div className="container mt-5">
      <div className="row">
        <div className="col-12 col-lg-6 d-flex align-items-center justify-content-center">
          <h1 className="responsivetxt-lg"style={{color:'#2F3B5E', fontFamily: 'Akkurat-Bold'  }}>
              Find the Perfect Services For Your Business
          </h1>
        </div>

        <div className="col-12 col-lg-6 d-flex align-items-center justify-content-center">
          <lottie-player
            src="https://assets8.lottiefiles.com/packages/lf20_bay0b2ga.json"
            background="transparent"
            speed="1"
            style={{ width: '100%' }}
            loop
            autoplay
          ></lottie-player>
        </div>
      </div>
    </div>

   
  </>
);

export default Packages;
